import React from 'react'
import { Fade } from 'react-awesome-reveal';

const IntroSection = () => {
  return (
    <section>
      <div className='intro-section mb-[4rem] xl:mb-[8rem] '>
        <Fade direction='up' triggerOnce={true}>
          <h1 className='hero-text text-[10vw] font-medium leading-[120%] md:text-[3.3rem] lg:text-[5rem] md:leading-[3.9rem] tracking-[-.0625rem] lg:max-w-[80rem] lg:leading-[5.625rem]'>
            Product-Focused Frontend Engineer, building digital products that feel effortless for users and drive growth for businesses.
          </h1>
          <p className='p-text mt-16 text-[6vw] leading-[2rem] md:text-[2rem] lg:text-[2rem] md:leading-[2.4rem] tracking-[-.0125rem] md:tracking-[-.0225rem] lg:max-w-[80rem] lg:leading-[3.625rem]'>
            I help startups and growing companies build fast, accessible, and scalable web products with a strong focus on usability, product thinking, and business outcomes. I believe the best software removes friction, builds trust, and helps people accomplish their goals with confidence.
          </p>

        </Fade>
      </div>
    </section>
  )
}

export default IntroSection